import React, { Component } from 'react';
import Notebook from './Notebook';
import Classic from './Classic';
import texts from '../Class/texts.json';

//fix it so that you can use formatting ie <p> etc

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            originaltext: texts['Why Write the Classics'], //change to marketing
            classictext:texts['Why Write the Classics'], //change to marketing
            value:'Delete this and copy the classic in here.',
            classic:'Why Write the Classics',
            heights: 'auto',
            changes:'1'
                    };
        
        this.trackChanges = this.trackChanges.bind(this);
        this.makeChanges = this.makeChanges.bind(this);
        this.handleChanges = this.handleChanges.bind(this);
        
    }

    trackChanges(event) {
        this.setState({value: event.target.value});
        
    
        if (event.target.value.length > this.state.originaltext.length) {
            var a = this.makeChanges(this.state.originaltext.length, event);
        }   else {
            var a = this.makeChanges(event.target.value.length, event);
        } 
        this.setState({classictext: a + this.state.originaltext.slice(event.target.value.length)})
    }    

    makeChanges(iter, event) {
        var a ='';
        var i;
        for (i = 0; i < iter; i++) {
            if (event.target.value.charAt(i) === this.state.originaltext.charAt(i)) {
                a += this.state.originaltext.charAt(i).fontcolor("green").bold();
            } else {
                a += this.state.originaltext.charAt(i).fontcolor("red").bold();
            }
        }
        return a
    }

    handleChanges(event) {
        this.setState({classic: event.target.value, originaltext: texts[event.target.value], classictext: texts[event.target.value]});
        //read json file pass event.target.value which should return classic text 
        //set the vaue to originaltext and classic text
    }

    componentDidMount() {
        
        const height = this.divElement.scrollHeight;
        console.log(height);

    }

    componentDidUpdate(prevProps) {
        const height = this.divElement.scrollHeight;
        if (height - 69 !== this.state.heights) {
        console.log(height);
        this.setState({heights: height - 69})
    }
    }



    render(){
        var divStyle = {
            height: this.state.heights + 'px',
            minHeight: '100%',
            minHeight:'100vh'
        }

        return (
            <div className='table' style={divStyle}>
            <Notebook 
                h={this.state.heights}
                value={this.state.value}
                controlFunc={this.trackChanges} />
            <div ref={(divElement) => this.divElement = divElement} className='a'>
            
            <Classic 
                classictext={this.state.classictext} 
                classic={this.state.classic} 
                onSelectorChange={this.handleChanges} />
            </div>
            </div>
        )
    }
}

export default Table


// WEBPACK FOOTER //
// ./src/components/Table.js